import React from 'react';

// import {images} from '../../constants'

const SubHeading = ({title, divCentrado}) => (
  <div style={{marginBottom:'1rem', textAlign:'center'}}>
    {divCentrado
      ?<div  style={{height:'1px', width:'30px', margin:'0px auto',borderRadius:'15px' ,border:'2px solid var(--color-brown-secondary)', background:'var(--color-brown-secondary)'} } />
      :<div  style={{height:'1px', width:'30px',borderRadius:'15px' ,border:'2px solid var(--color-brown-secondary)', background:'var(--color-brown-secondary)'} } />
    }
    <p className="p__cormorant">{title}</p>
    {/* <img  src={images.spoon} alt="spoon" className="spoon_img" /> */}

  </div>
);

export default SubHeading;
